/* The Barn Dallas, lightweight theme interactivity
   Mobile menu, product gallery, accordions, qty stepper */
(function () {
  'use strict';

  /* ------- Mobile drawer ------- */
  const drawerToggles = document.querySelectorAll('[data-drawer-toggle]');
  drawerToggles.forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-drawer-toggle');
      const drawer = document.getElementById(id);
      if (!drawer) return;
      const open = drawer.getAttribute('aria-hidden') === 'false';
      drawer.setAttribute('aria-hidden', open ? 'true' : 'false');
      document.body.style.overflow = open ? '' : 'hidden';
    });
  });

  /* ------- Product gallery thumbnails ------- */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.setAttribute('aria-selected', 'false'));
        thumb.setAttribute('aria-selected', 'true');
        const src = thumb.getAttribute('data-src');
        const alt = thumb.getAttribute('data-alt') || '';
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.alt = alt;
        }
      });
    });
  });

  //* ------- Variant pills with inventory awareness ------- */
  document.querySelectorAll('form[data-product-form], form').forEach((form) => {
    const variantScript = form.querySelector('script[data-product-variants]');
    if (!variantScript) return;

    let variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }

    const groups = form.querySelectorAll('[data-variant-group]');
    if (!groups.length) return;

    function readSelections() {
      const sel = [];
      groups.forEach((g) => {
        const pressed = g.querySelector('[data-variant-pill][aria-pressed="true"]');
        sel.push(pressed ? pressed.getAttribute('data-value') : null);
      });
      return sel;
    }

    function refreshSoldOut() {
      const sel = readSelections();
      groups.forEach((group, gIdx) => {
        const pills = group.querySelectorAll('[data-variant-pill]');
        pills.forEach((pill) => {
          const val = pill.getAttribute('data-value');
          const trial = sel.slice();
          trial[gIdx] = val;

          const match = variants.some((v) => {
            if (!v.available) return false;
            for (let i = 0; i < trial.length; i++) {
              if (trial[i] != null && v.options[i] !== trial[i]) return false;
            }
            return true;
          });

          if (match) {
            pill.classList.remove('variant-pill--sold-out');
            pill.setAttribute('data-available', 'true');
            pill.removeAttribute('aria-disabled');
          } else {
            pill.classList.add('variant-pill--sold-out');
            pill.setAttribute('data-available', 'false');
            pill.setAttribute('aria-disabled', 'true');
          }
        });
      });
    }

    function syncSelectedVariant() {
      const sel = readSelections();
      const match = variants.find((v) => {
        for (let i = 0; i < sel.length; i++) {
          if (sel[i] != null && v.options[i] !== sel[i]) return false;
        }
        return true;
      });
      if (!match) return;
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }

    groups.forEach((group) => {
      const pills = group.querySelectorAll('[data-variant-pill]');
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((p) => p.setAttribute('aria-pressed', 'false'));
          pill.setAttribute('aria-pressed', 'true');

          const labelTarget = group.querySelector('[data-variant-selected]');
          if (labelTarget) labelTarget.textContent = pill.getAttribute('data-value') || pill.textContent;

          refreshSoldOut();
          syncSelectedVariant();
        });
      });
    });

    refreshSoldOut();
  });
  /* ------- Quantity stepper ------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change'));
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ------- Sticky header shadow on scroll ------- */
  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        header.style.boxShadow = window.scrollY > 8 ? '0 1px 0 rgba(0,0,0,0.06)' : 'none';
        ticking = false;
      });
    }, { passive: true });
  }
})();
